import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import NavbarComponent from './Navbar';
import FooterComponent from './Footer';
import Seo from '../components/Seo'
import('../css/BasicFaq.css')


const FAQPage = () => {
  const faqs = [
    {
      question: "How do I list my land on KhetBazaar?",
      answer: "Listing your land is simple. Sign up for an account, click on 'Sell Land', fill in the required details about your land, upload photos, and set your price. Our team will verify your listing within 24 hours."
    },
    {
      question: "What types of properties can I find on KhetBazaar?",
      answer: "KhetBazaar features various types of land including agricultural land, residential plots, commercial properties, and industrial lands. All listings are verified for authenticity."
    },
    {
      question: "Is it safe to buy land through KhetBazaar?",
      answer: "Yes, KhetBazaar ensures safety by verifying all property listings and seller information. Buyers can directly contact property owners through our platform to discuss details and negotiate. While we verify basic property information, we recommend buyers conduct their own legal checks and documentation verification before finalizing any deals."
    },
    {
      question: "How does the leasing process work?",
      answer: "Property owners can list their land for lease, specifying terms and duration. Interested parties can contact owners through our platform. We help facilitate the agreement and provide standard lease contract templates."
    },
    {
      question: "What documents do I need to sell my land?",
      answer: "You'll need ownership documents, land survey certificates, tax clearance, and identity proof. Our team will guide you through the required documentation process."
    },
    {
      question: "Can I negotiate prices on KhetBazaar?",
      answer: "Yes, buyers can directly negotiate with sellers through our platform's contact information. We encourage transparent communication between parties."
    }
  ];

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (

    <>
      <Seo
        title="FAQs - KhetBazaar"
        description="Frequently Asked Questions about buying, selling, and leasing land."
        canonical="https://khetbazaar.in/faqs"
      />

      <div className="faq-page">
        <NavbarComponent />
        <div className="faq-header">
          <h1>Frequently Asked Questions</h1>
          <p>Find answers to common questions about KhetBazaar</p>
        </div>

        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${activeIndex === index ? 'active' : ''}`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                <h3>{faq.question}</h3>
                <ChevronDown className="faq-icon" />
              </div>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
        <FooterComponent />
      </div>
    </>
  );
};

export default FAQPage;